import React, { FunctionComponent, useCallback, useMemo } from 'react';
import { StateValues } from 'react-use-form-state';
import { AdminApi, AdminOrganizationRequest, AdminOrganizationsServiceContractsUpdateRequest } from 'api';
import useApiCall from 'hooks/use-api-call';
import { makeModalForm } from 'ui/molecules/modal';
import AddOrganizationModal, { AddOrganizationFields } from '../add-organization-modal';

interface AddOrganizationProps {
  onAddNewOrganization: () => void;
  onClose: () => void;
}

export const Form = makeModalForm<AddOrganizationFields>();

const AddOrganization: FunctionComponent<AddOrganizationProps> = ({ onAddNewOrganization, onClose }) => {
  const { makeAuthenticatedApi, withApi, error } = useApiCall();

  const api: AdminApi = useMemo(() => makeAuthenticatedApi(AdminApi), [makeAuthenticatedApi]);

  const onSubmit = useCallback((fieldsValues: StateValues<AddOrganizationFields>) => {
    const params: AdminOrganizationRequest = {
      name: fieldsValues.name,
      loginType: fieldsValues.loginType,
    };

    withApi(async () => {
      const response = await api.adminOrganizationsCreate({ adminOrganizationRequest: params });

      for (const serviceContract of fieldsValues.serviceContracts) {
        const serviceContractParams: AdminOrganizationsServiceContractsUpdateRequest = {
          id: response.id,
          techName: serviceContract,
          adminOrganizationRequest: {
            name: fieldsValues.name,
          },
        };
        await api.adminOrganizationsServiceContractsUpdate(serviceContractParams);
      }

      onAddNewOrganization();
    });
  }, []);

  return <AddOrganizationModal onSubmit={onSubmit} onClose={onClose} error={error} />;
};

export default AddOrganization;
